import { createAsyncThunk } from '@reduxjs/toolkit';
import { httpService } from '@flexo/general';

const ENV = (import.meta as any).env;

/**
 * Fetch all API keys for the organization
 */
export const FetchApiKeysAsync = createAsyncThunk(
  'apiKeys/FetchApiKeysAsync',
  async function () {
    const response = await httpService.get({
      url: `${ENV.VITE_APP_BASE_URL}/community/catalog/v1_4/organization/api-keys`,
      mock: false,
    });

    if (response.status === 200) {
      return { apiKeys: response.data?.apiKeys || [] };
    }
    throw new Error('Failed to fetch API keys');
  }
);

/**
 * Create a new API key
 */
export const CreateApiKeyAsync = createAsyncThunk(
  'apiKeys/CreateApiKeyAsync',
  async function (data: { name: string; catalogUserId?: string }) {
    const response = await httpService.post({
      url: `${ENV.VITE_APP_BASE_URL}/community/catalog/v1_4/organization/api-keys`,
      data: {
        name: data.name,
        catalogUserId: data.catalogUserId,
      },
      mock: false,
    });

    if (response.status === 200 || response.status === 201) {
      return { createdKey: response.data };
    }
    throw new Error('Failed to create API key');
  }
);

/**
 * Revoke an API key
 */
export const RevokeApiKeyAsync = createAsyncThunk(
  'apiKeys/RevokeApiKeyAsync',
  async function (keyName: string) {
    const response = await httpService.delete({
      url: `${ENV.VITE_APP_BASE_URL}/community/catalog/v1_4/organization/api-keys/${encodeURIComponent(keyName)}`,
      mock: false,
    });

    if (response.status === 200) {
      return { keyName };
    }
    throw new Error('Failed to revoke API key');
  }
);

/**
 * Audit API keys configuration
 */
export const AuditApiKeysAsync = createAsyncThunk(
  'apiKeys/AuditApiKeysAsync',
  async function () {
    const response = await httpService.get({
      url: `${ENV.VITE_APP_BASE_URL}/community/catalog/v1_4/organization/api-keys/audit`,
      mock: false,
    });

    if (response.status === 200) {
      return { audit: response.data };
    }
    throw new Error('Failed to audit API keys');
  }
);
